<template>
  <div>
    <v-container fluid>
			<v-row>
				<v-col cols="12" class="d-flex pl-0">
					<v-icon color="white" @click="toggleMfaInfo">mdi-information</v-icon>
					<span class="white--text pl-1">Choose your two-factor authentication method:</span>
				</v-col>
			</v-row>
			<v-row>
				<v-radio-group  v-model="mfaType" class="radio-button-group">
					<v-radio color="white" label="Enable two-factor authentication via text message" value="sms"></v-radio>
					<v-radio color="white"  label="I don't want to enable two-factor authentication right now" value="none"></v-radio>
				</v-radio-group>
			</v-row>

			<br>

			<v-layout justify-space-between align-content-center>
				<v-row class="pl-0">
					<v-spacer/>
					<v-col cols="12" sm="6" class="bottom-row-align forgot-pw">
						<v-btn
							color="#3db0ad"
							class="white--text override-bg"
							@click.prevent="submit"
						>Next</v-btn>
						
					</v-col>
				</v-row>

				<v-dialog v-model="displayMfaInfo" persistent class="mfa-nag">
					<v-card width="700" class="pa-4">
						<v-row>
							<v-col cols="12">
								Two factor authentication is highly recommended to protect the security of your account.
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12">
								Choose "Enable two-factor authentication via text message" if you wish to recieve a login confirmation code on your mobile phone each time you log in.
							</v-col>
						</v-row>
						<v-row>
							<v-spacer/>
							<v-col cols="3">	
								<v-btn 
									color="#3db0ad" 
									class="white--text"
									size="small"
									variant="flat"
									@click="toggleMfaInfo"
								>
									Dismiss
								</v-btn>
							</v-col>
						</v-row>
					</v-card>
				</v-dialog>
			</v-layout>
		</v-container>
  </div>
</template>

<script>
export default {
	name: 'SetupMfa',
	data() {
		return {
			mfaType: 'sms',
			displayMfaInfo: false
		}
	},

	methods: {
		toggleMfaInfo() {
			this.displayMfaInfo = !this.displayMfaInfo
		},

		submit() {
			// eslint-disable-next-line no-console
			console.log('submit', this.mfaType)
			if(this.mfaType == 'sms') {
				// eslint-disable-next-line no-console
				console.log('setupSmsMfa')
				this.$emit('setupSmsMfa')
			}
			else if (this.mfaType == 'app') {
				this.$emit('setupAppMfa')
			}
			else if (this.mfaType == 'none') {
				this.$emit('skipMfa')
			}
		}
	}
}
</script>

<style lang="scss">
.v-input--radio-group--column .v-input--radio-group__input {
	background: rgb(19, 41, 75) !important;
}
.v-input--selection-controls .v-input__slot > .v-label, .v-input--selection-controls .v-radio > .v-label {
	color: white !important;
}
.v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
	margin-bottom: 24px;
}

.theme--light.v-icon {
	color: white !important;
}

</style>